@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Minnesota</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <div
        class="axis-form-group _mt-medium"
        [ngClass]="{
          'has-axis-error':
            reactiveForm.get(controls[0].formControlName)?.touched &&
            reactiveForm.get(controls[0].formControlName)?.invalid,
        }"
      >
        @if (controls?.length >= 1) {
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <div class="axis-error-block">Please select an option.</div>
            }
          }
        }
      </div>
      <div class="axis-grid">
        @if (
          (baseRules["OPTIONS_DropDown"]?.includes("show") || baseRules["OPTIONS_DropDown"]?.includes("form")) &&
          !hideOptionsDropdown
        ) {
          <div class="axis-col-6">
            <div
              class="axis-form-group _mt-medium"
              [ngClass]="{
                'has-axis-required':
                  !reactiveForm.get(controls[1].formControlName)?.value ||
                  (reactiveForm.get(controls[1].formControlName)?.value?.name === '' &&
                    reactiveForm.get(controls[1].formControlName)?.value?.value === ''),
                'has-axis-error':
                  reactiveForm.get(controls[1].formControlName)?.touched &&
                  reactiveForm.get(controls[1].formControlName)?.invalid,

                '_ml-xlarge': baseRules.Show_Indent,
              }"
            >
              @if (baseRules["VaryByState_Options"] === "show") {
                <label
                  class="axis-control-label"
                  for="{{ controls[1].formControlName }}"
                >
                  {{ textValues?.IncreaseMinimumLimit_LevelOne_Radio_text }}
                </label>
              }
              <label
                class="axis-control-label"
                for="{{ controls[1].formControlName }}"
                >{{ controls[1].label }}
                <span
                  aria-hidden="true"
                  class="axis-required-indicator"
                  >*</span
                >
              </label>
              <axis-dropdown
                [dataProvider]="controls[1].data"
                (onSelect)="
                  optionsSelection = {
                    Total_Medical_Expenses: $event.Total_Medical_Expenses,
                    Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss:
                      $event.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss,
                    Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions:
                      $event.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions,
                    Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services:
                      $event.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services,
                  }
                "
                id="{{ controls[1].formControlName }}"
                formControlName="{{ controls[1].formControlName }}"
              ></axis-dropdown>
              @if (reactiveForm.get(controls[1].formControlName)?.touched) {
                @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
                  <div class="axis-error-block">Please select an option.</div>
                }
              }
            </div>
          </div>
        }
      </div>
      <div class="axis-grid">
        @if (optionsSelection.Total_Medical_Expenses) {
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group _mt-medium">
              <label class="axis-control-label">
                {{ textValues?.Total_Medical_Expenses_Text }}
              </label>
              <div>{{ optionsSelection.Total_Medical_Expenses }}</div>
            </div>
          </div>
        }
        @if (
          optionsSelection.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss
        ) {
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group _mt-medium">
              <label class="axis-control-label">
                {{
                  textValues?.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss_Text
                }}
              </label>
              <div>
                {{
                  optionsSelection.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss
                }}
              </div>
            </div>
          </div>
        }
        @if (optionsSelection.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions) {
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group _mt-medium">
              <label class="axis-control-label">
                {{ textValues?.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions_Text }}
              </label>
              <div>
                {{ optionsSelection.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions }}
              </div>
            </div>
          </div>
        }
        @if (optionsSelection.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services) {
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group _mt-medium">
              <label class="axis-control-label">
                {{ textValues?.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services_Text }}
              </label>
              <div>
                {{ optionsSelection.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services }}
              </div>
            </div>
          </div>
        }
      </div>
    </form>
  }
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Minnesota</h2>
  @if (baseRules?.noSelection === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">{{ textValues?.Reject_Text }}</label>
    </div>
  }
}
